import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export const trackEvent = async (eventType, page = null) => {
  try {
    await axios.post(`${API}/analytics/track`, {
      event_type: eventType,
      page: page || window.location.pathname,
      user_agent: navigator.userAgent,
      referrer: document.referrer
    });
  } catch (error) {
    // Silently fail - don't interrupt user experience
    console.debug('Analytics tracking failed:', error);
  }
};

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackEvent('page_view', location.pathname);
  }, [location.pathname]);

  // Track app open on mount
  useEffect(() => {
    // Check if running as installed PWA
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
                         window.navigator.standalone ||
                         document.referrer.includes('android-app://');
    
    if (isStandalone) {
      trackEvent('app_open');
    }
  }, []);

  return { trackEvent };
};

// Track PWA install
export const trackAppInstall = () => {
  trackEvent('app_download');
};
